import { h } from 'preact'
import classNames from 'classnames'
import formatDateInLocalTimezone from '../utils/dateFormatting'

type Props = {
  updatedBy: string,
  updatedAt: string,
  isLoading: boolean
}

const TeamNotesLastEdited = ({ updatedBy, updatedAt, isLoading }: Props) => (
  <div>
    <div class={classNames(
      'team-notes__metadata-last-edited', {
        'team-notes__metadata-last-edited--is-loading': isLoading
      })}
    >
      Last edited by <span class='team-notes__metadata-author'>{updatedBy}</span> on {formatDateInLocalTimezone(updatedAt)}
    </div>
  </div>
)

export default TeamNotesLastEdited
